import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {StyleService} from '../../../Services/style.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-style-overview',
  templateUrl: './style-overview.component.html',
  styleUrls: ['./style-overview.component.scss']
})
export class StyleOverviewComponent implements OnInit {
  public grid: Grid;
  public styleId: number;
  public styleName: string;

  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  // @ViewChild('collectionRowDetail') collectionRowDetail: any;

  constructor(
    private styleService: StyleService,
    private broadcastService: BroadcastService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.style.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <NumberColumn>{
          name: 'global.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.styleService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getStyle');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/style/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.styleId = row.id;
                this.styleName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.styleService,
      rememberURL: this.router.url,
      method: 'getStyle',
      defaultSort: 'position',
      // rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,

    };
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/style/archive');
  }

  softDelete() {
    this.styleService.softDeleteStyle(this.styleId).subscribe(res => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getStyle');
    });
  }

}
